import { render, staticRenderFns } from "./CardTag.vue?vue&type=template&id=72a3aec4&scoped=true"
import script from "./CardTag.vue?vue&type=script&lang=js"
export * from "./CardTag.vue?vue&type=script&lang=js"
import style0 from "./CardTag.vue?vue&type=style&index=0&id=72a3aec4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a3aec4",
  null
  
)

export default component.exports